import { render } from "./IconAltUp.vue?vue&type=template&id=363b9671"
import script from "./IconAltUp.vue?vue&type=script&lang=js"
export * from "./IconAltUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__